var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMsTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,3c-1.19974,0.00073 -2.31551,0.61591 -2.95649,1.63007c-0.64098,1.01416 -0.71784,2.28596 -0.20367,3.36993h-9.33984c-1.105,0 -2,0.895 -2,2v10c0,1.105 0.895,2 2,2h10c1.105,0 2,-0.895 2,-2v-10c0,-0.01274 -0.00367,-0.02442 -0.00391,-0.03711c0.16686,0.02449 0.33526,0.0369 0.50391,0.03711c1.933,0 3.5,-1.567 3.5,-3.5c0,-1.933 -1.567,-3.5 -3.5,-3.5zM24,5c-1.38071,0 -2.5,1.11929 -2.5,2.5c0,1.38071 1.11929,2.5 2.5,2.5c1.38071,0 2.5,-1.11929 2.5,-2.5c0,-1.38071 -1.11929,-2.5 -2.5,-2.5zM6,11h2.5h1h2.5v1h-2.5v7h-1v-7h-2.5zM18,12v8c0,2.21 -1.79,4 -4,4h-2.98047c1.16,1.8 3.18047,3 5.48047,3c3.59,0 6.5,-2.91 6.5,-6.5v-6.5c0,-1.1 -0.9,-2 -2,-2zM24.46094,12c0.34,0.59 0.53906,1.27 0.53906,2v6.5c0,0.85 -0.11938,1.66945 -0.35937,2.43945c1.91,-0.3 3.35938,-1.94945 3.35938,-3.93945v-5c0,-1.1 -0.9,-2 -2,-2z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMsTeams);
export default __webpack_public_path__ + "static/media/icon-ms-teams.c2cff37f5b111cea8cb19e412315140e.svg";
export { ForwardRef as ReactComponent };